export const SharedDotcomConstants = {
    TRANSLATION_NAMESPACE: 'usanadotcom',
    /**
     * Default locales for the new dotcom landing page experience.
     * Used as a fallback when the production deployment key is not set.
     */
    DOTCOM_LANDING_LOCALES: [
        'enu-US', 'spa-US', 'zhs-US', 'zht-US',
        'enu-AU', 'zhs-AU', 'zht-AU',
        'enu-NZ', 'zhs-NZ', 'zht-NZ',
        'enu-CA', 'fre-CA', 'zhs-CA', 'zht-CA',
        'enu-HK', 'zhs-HK', 'zht-HK',
        'enu-PH',
        'kor-KR',
    ],

    PLACEHOLDER_IMG: 'assets/placeholder.jpeg',

    /**
     * /opportunity renders one of three pages depending on the session locale
     * (3-char teas form, e.g. "enu-US"). These two lists drive that dispatch in
     * OpportunitySwitcherComponent; any locale not listed falls back to the
     * generic OpportunityComponent.
     *
     *   OPPORTUNITY_SHARE_LOCALES        → ShareTableComponent (u-share-table)
     *   OPPORTUNITY_SHARE_AND_EARN_LOCALES → ShareAndEarnComponent
     */
    OPPORTUNITY_SHARE_LOCALES: ['enu-IN'],

    OPPORTUNITY_SHARE_AND_EARN_LOCALES: [
        'enu-US', 'zhs-US', 'zht-US', 'spa-US',
        'fre-CA', 'zhs-CA', 'zht-CA', 'enu-CA',
        'enu-MY', 'msa-MY', 'zhs-MY', 'zht-MY',
        'enu-PH',
        'enu-ES',
        'enu-SG', 'zhs-SG', 'zht-SG',
        'enu-AU', 'zhs-AU', 'zht-AU',
        'enu-NZ', 'zhs-NZ', 'zht-NZ',
        'enu-HK', 'zhs-HK', 'zht-HK',
        'spa-MX',
        'spa-CO',
        'jpn-JP',
        'zhs-TW', 'zht-TW',
        'tha-TH',
    ],
};
